<template>
  <footer id="footer" :class="footerClass">
    <b-container style="text-align: center;">
      <span style="font-size: 10px;" class="text-muted">Power by</span>
      <b-img class="footer_img"
             src="https://firebasestorage.googleapis.com/v0/b/la-llucana.appspot.com/o/Logo_lallucana_A4.svg?alt=media&token=ebc33f0d-d2d2-4465-a78d-4830b60551bf"/>
    </b-container>
  </footer>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: "Footer",
  computed: {
    ...mapState(['footerClass'])
  }
}
</script>

<style scoped>
.footer {
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  clear: both;
  position: absolute;
  left: 0;
  right: 0;
  min-height: 63px;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}

.footerRelative {
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  clear: both;
  position: relative;
  left: 0;
  right: 0;
  min-height: 63px;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}

.footerDisplayNone {
  display: none;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  clear: both;
  position: absolute;
  left: 0;
  right: 0;
  min-height: 63px;
  text-align: center;
  padding: 10px;
  box-sizing: border-box;
}

.footer_img {
  width: 63px;
}
</style>
